<ng-container *ngIf="identityService.isLoggedIn; else loginButton">
  <a
    role="button"
    class="account-button nav-link link-light px-2"
    [ngbPopover]="accountBox"
    autoClose="outside"
    placement="bottom-end"
    data-automation-id="My-Account-button"
    #popoverRef="ngbPopover"
    ><digital-platform-icon
      icon="user-outline"
      color="white"
      [height]="17"
      [width]="17"
    ></digital-platform-icon>
    <span class="margin-left-s"> My Account</span>
    <span
      class="chevron-icon"
      [class.chevron-icon--rotate]="popoverRef.isOpen()"
    ></span>
  </a>
  <ng-template #accountBox>
    <digital-platform-account-dropdown-box
      (linkClick)="popover.close()"
    ></digital-platform-account-dropdown-box>
  </ng-template>
</ng-container>
<ng-template #loginButton>
  <a
    [href]="loginRoute"
    class="account-button nav-link link-light px-2"
    popoverTitle="Login to your account"
    placement="bottom"
    data-automation-id="Login-button"
    (click)="login($event)"
    ><digital-platform-icon
      icon="user-outline"
      color="white"
      [height]="17"
      [width]="17"
      class="digital-platform-icon"
    ></digital-platform-icon>
    Log In</a
  >
</ng-template>
